import { render, staticRenderFns } from "./CsAsignacionesIndex.vue?vue&type=template&id=013efd60"
import script from "./CsAsignacionesIndex.vue?vue&type=script&lang=js"
export * from "./CsAsignacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports